module.exports = __webpack_public_path__ + "assets/img/images_m.e0a7bf9e.png";